import { UseDataQueryKey } from '../../../hooks/useDataQuery/dataQuery.types';
import { formatFilterIdsSearchParams } from '../../../modules/catalogs/products/catalogFilters.utils';
import {
  GetCatalogProductsPageKeyParams,
  GetCatalogProductsPageKeyPrefixParams,
} from './catalogProducts.types';

export const CATALOG_PRODUCTS_KEY_SEGMENT = 'catalog-products';

export const getCatalogProductsPageKeyPrefix = ({
  catalogId,
  contextParams,
  sortParams,
  groupParams,
  filters,
  customerIds,
  gridDataInclude,
}: GetCatalogProductsPageKeyPrefixParams): UseDataQueryKey => [
  CATALOG_PRODUCTS_KEY_SEGMENT,
  catalogId,
  contextParams,
  sortParams,
  groupParams,
  formatFilterIdsSearchParams(filters, customerIds),
  gridDataInclude,
];

export const getCatalogProductsPageKey = ({
  catalogId,
  contextParams,
  sortParams,
  groupParams,
  filters,
  customerIds,
  gridDataInclude,
  page,
}: GetCatalogProductsPageKeyParams): UseDataQueryKey => [
  ...getCatalogProductsPageKeyPrefix({
    catalogId,
    contextParams,
    sortParams,
    groupParams,
    filters,
    customerIds,
    gridDataInclude,
  }),
  page,
];
